import { Outlet } from 'react-router-dom';
import '../styles/Layout.css';
import HamburgerMenu from './HambugerMenu';
import Header from './Header';

const Layout = ({ menuOpen, setMenuOpen }) => {
  return (
    <div className={`layout-container ${menuOpen ? 'menu-open' : ''}`}>
      <Header setMenuOpen={setMenuOpen} />
      <HamburgerMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <main className="main-content">
        <Outlet /> {/* tempat semua halaman di-load */}
      </main>
    </div>
  );
};

export default Layout;
